import {
  LAYOUT_COMPONENT_TYPE,
  REGISTRY_BLOCK,
  type LayoutBlock,
} from '@web-studio/shared-schemas';
import { loc3 } from '../locales';
import { FIXTURE_BLOCK_IDS } from '../uuids';

export const reservationFormEmbedDefault: LayoutBlock = {
  blockId: FIXTURE_BLOCK_IDS.reservation,
  componentType: LAYOUT_COMPONENT_TYPE.reservationFormEmbed,
  registryBlockKey: REGISTRY_BLOCK.presentation.reservationFormEmbed,
  displayOrder: 4,
  content: {
    heading: loc3('Reservierung', 'Reservation', 'Đặt bàn'),
    supporting: loc3(
      'Senden Sie uns Ihre Wunschzeit und wir bestätigen zeitnah.',
      'Send us your preferred time and we will confirm shortly.',
      'Gửi thời gian mong muốn, chúng tôi xác nhận sớm.',
    ),
    ctaLabel: loc3('Anfrage senden', 'Send request', 'Gửi yêu cầu'),
  },
  media: {},
};

export const reservationThirdPartyBookDefault: LayoutBlock = {
  blockId: FIXTURE_BLOCK_IDS.reservationThirdParty,
  componentType: LAYOUT_COMPONENT_TYPE.reservationThirdPartyBook,
  registryBlockKey: REGISTRY_BLOCK.presentation.reservationThirdPartyBook,
  displayOrder: 4,
  content: {
    heading: loc3('Tisch online reservieren', 'Reserve a table online'),
    supporting: loc3(
      'Prüfen Sie Verfügbarkeit und buchen Sie direkt über unser Reservierungssystem.',
      'Check availability and book directly through our reservation system.',
    ),
    ctaLabel: loc3('Jetzt reservieren', 'Book now'),
    bookingUrl: loc3('https://www.resmio.com/', 'https://www.resmio.com/'),
    note: loc3(
      'Sie werden zu unserem Buchungspartner weitergeleitet.',
      'You will be redirected to our booking partner.',
    ),
  },
  media: {},
};

export const reservationMessengerBookDefault: LayoutBlock = {
  blockId: FIXTURE_BLOCK_IDS.reservationMessenger,
  componentType: LAYOUT_COMPONENT_TYPE.reservationMessengerBook,
  registryBlockKey: REGISTRY_BLOCK.presentation.reservationMessengerBook,
  displayOrder: 4,
  content: {
    heading: loc3('Per Nachricht reservieren', 'Reserve by message'),
    supporting: loc3(
      'Schreiben Sie uns Wunschdatum, Uhrzeit und Personenanzahl — wir antworten schnell.',
      'Message us your preferred date, time, and party size — we reply quickly.',
    ),
    ctaLabel: loc3('WhatsApp öffnen', 'Open WhatsApp'),
    messengerUrl: loc3('https://wa.me/491701234567', 'https://wa.me/491701234567'),
    note: loc3(
      'Antwortzeiten können außerhalb der Öffnungszeiten länger sein.',
      'Replies may take longer outside opening hours.',
    ),
  },
  media: {},
};

export const reservationCallBookDefault: LayoutBlock = {
  blockId: FIXTURE_BLOCK_IDS.reservationCall,
  componentType: LAYOUT_COMPONENT_TYPE.reservationCallBook,
  registryBlockKey: REGISTRY_BLOCK.presentation.reservationCallBook,
  displayOrder: 4,
  content: {
    heading: loc3('Telefonisch reservieren', 'Reserve by phone'),
    supporting: loc3(
      'Rufen Sie uns an — wir nehmen Ihre Reservierung persönlich entgegen.',
      'Call us — we will take your reservation personally.',
    ),
    ctaLabel: loc3('Jetzt anrufen', 'Call now'),
    phoneNumber: loc3('+49 30 1234567', '+49 30 1234567'),
    note: loc3(
      'Am besten während der Öffnungszeiten erreichen Sie uns.',
      'Best reached during opening hours.',
    ),
  },
  media: {},
};
